import React, { useEffect } from "react";
import { useState, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Cookies from "js-cookie";
import { config } from "../api/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { use } from 'react';

const MotorInsuranceBuyPolicy = () => {
  const navigate = useNavigate(); //to navigate to pages...

  
      const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    
    
      const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const [allow,setAllow]=  useState(false);
  const base_url = config.baseURL;
  // const vendor_key =
  //   "yeflesxnwar1xh31o6pg4ww9fr03ohn74u4h6oy0xx4qpzot0aqbhwlhbiv55k0qf1bls12v7zrlhriuu77wcytijxdzvfrfnxlhq68y30eiy59ok01iyn1xzyangrew9w19cchvd62js5164j4bmfcauj3vc7qkpqkjdl7hdpzxc2xzoq35ehuq3gzybhh1rc3v6tr5slr2ivv958ixq35k5meh3626v3g9sckyp267o8vup7kd72ntp9udknjz";
  const [vendorKey, setVendorkey] = useState("");
  const selectOpt1 = useRef(null);
  const selectOpt2 = useRef(null);

  const firstNameRef = useRef(null);
  const mobileNoRef = useRef(null);
  const plateNoRef = useRef(null);
  const registrationMarkRef = useRef(null);
  const plateRegTypeRef = useRef(null);
  const civilIdRef = useRef(null);
  const vehicleValueRef = useRef(null);
  const [userData, setUserData] = useState();

  const reg_type = ["Oman", "GCC Plate", "Import", "Export"];
   const reg_mark =  [
  "A","A A","A B","A D","A K","A M","A R","A S","A W","A Y",
  "Abu Dhabi","Ajman",
  "B","B A","B B","B D","B H","B K","B M","B R","B S","B W","B Y",
  "Bahrain","BANK",
  "C D",
  "D","D A","D D","D H","D K","D R","D S","D W","D Y",
  "Dubai",
  "Fujairah",
  "H","H A","H D","H H","H K","H M","H R","H S","H W","H Y",
  "I N T L","IMPORT","Inspection",
  "J",
  "K","K A","K B","K H","K K",
  "KSA","Kuwait",
  "L A","L A","L B","L D","L H","L K",
  "M","M A","M B","M D","M H","M K","M L","M M","M R","M S","M W","M Y","MUSCAT",
  "Qatar",
  "R","R A","R H","R K","R M","R R","R S","R W","R Y","Ras Al - Khaimah",
  "S","S H","S S",
  "Sharjah",
  "T","T A","T B","T B A","T D","T H","T T",
  "UAE","Umm Al - Quwain",
  "W","W A","W B","W K","W W",
  "Y","Y A","Y B","Y D","Y M","Y R","Y S","Y W","Y Y",
  "1","2","3","4","5","6","7","8","9",
  "10","11","12","14","15","16","17","18","19",
  "20","21","22","23","24","25","26","27","28","29",
  "30","31","32","33","34","35","36","37","38","39",
  "40","41","42","43","44","45","46","47","48","49",
  "50","51","52","53","54","55","56","57","58","59",
  "60","61","62","63","64","65","66","67","68","69",
  "70","71","72","73","74","75","76","77","78","79",
  "80","81","82","83","84","85","86","87","88","89",
  "90","91","92","999"
];

  const [formData, setFormData] = useState({
    mobileNo: "",
    plateNo: "",
    registrationMark: "",
    plateRegType: "",
    product: "",
    civilId: "",
    firstName: "",
    vehicleValue: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(null);
  const [openMessageBox, setOpenMessageBox] = useState(false);

    useEffect(() => {
          const storedUserString = Cookies.get('userData');
          if (storedUserString !== undefined) {
            const user_data = JSON.parse(storedUserString);
          
            setUserData(user_data);
            
            
          } else {
          //   alert('Login Session Expired');
          //   window.location.href = '/';
          }
      
        }, []);

        useEffect(()=>{
           const getBasicInfo=sessionStorage.getItem("motorBasicDetails");
           if(!getBasicInfo){
              window.location.href="/motor-insurance-page"
           }
           else{
            setAllow(true);
           }
        },[])

  // handle button selection
  const handleClick = (buttonId) => {
    setActiveButton(buttonId);

    const valueToStore = buttonId === 1 ? "0501" : "0502";
    setFormData((prevData) => ({
      ...prevData,
      product: valueToStore,
    }));
    const value = buttonId === 2 ? 0 : formData.vehicleValue;
    setFormData((prevData) => ({
      ...prevData,
      vehicleValue: value,
    }));
  };

  // ✅ common change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimValue = value.trimStart();

    const numberRegex = /^[0-9]*$/;
    const nameRegex = /^[A-Za-z\s]*$/;

    const numberFields = ["mobileNo", "plateNo", "civilId", "vehicleValue"];

    if (numberFields.includes(name)) {
      if (numberRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
      return;
    }

    if (name === "firstName") {
      if (nameRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
    } else {
      setFormData({ ...formData, [name]: trimValue });
    }
  };

  useEffect(() => {
    const createOrganization = async () => {
      try {
        const postvData = { organization_name: "Superjet" };

        const response = await fetch(base_url + "/create_organization", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(postvData),
        });
        const data = await response.json();
        setVendorkey(data.result[0].vendor_key);
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    if (!vendorKey) {
      createOrganization();
    }
  }, [vendorKey, base_url]);

  // form validation function
  const validateForm = () => {
    let newErrors = {};

    // Validate fields
    // if (!formData.mobileNo.trim()) {
    //   newErrors.mobileNo = "Mobile number is required";
    // }

    if (!formData.plateNo?.trim()) {
      newErrors.plateNo = "Plate number is required";
    }
    if (!formData.registrationMark?.trim() || formData.registrationMark.includes("--")) {
      newErrors.registrationMark = "Plate Code is required";
    }
    //    if (!formData.plateRegType.trim()) {
    //   newErrors.plateRegType = "Plate Type is required";
    // }

    if (!formData.civilId?.trim()) {
      newErrors.civilId = "Civil ID / License number is required";
    }

    // if (!formData.firstName.trim()) {
    //   newErrors.firstName = "Full name is required";
    // }
    if (!activeButton) {
      newErrors.product = "Product is Required";
    }

    if (
      activeButton === 1 &&
      (!formData.vehicleValue || formData?.vehicleValue === "0")
    ) {
      newErrors.vehicleValue =
        "Vehicle value is required for Comprehensive Insurance";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      switch (firstErrorField) {
        // case "mobileNo":
        //   mobileNoRef.current.focus();
        //   break;
        case "plateNo":
          plateNoRef.current.focus();
          break;
        case "civilId":
          civilIdRef.current.focus();
          break;
        // case "firstName":
        //   firstNameRef.current.focus();
        //   break;

        case "vehicleValue":
          vehicleValueRef.current.focus();
          break;
        default:
          break;
      }
      return false;
    }

    return Object.keys(newErrors).length === 0; // If no errors, return true
  };

  // const handleValidation = (e) => {

  //             const { name } = e.target;
  //    if (formData[name]?.trim()) {
  //     setErrors((prev) => ({ ...prev, [name]: "" }));
  //   }

  //        }

  const handleValidation = (e) => {
    const { name } = e.target;
    const value = (formData[name] ?? "").toString().trim();

    if (value) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleValidationRegMark = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (!value || value == null) {
      setErrors((prev) => ({
        ...prev,
        [name]: name + " is required",
      }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleValidationRegType = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (!value || value.includes("--")) {
      setErrors((prev) => ({
        ...prev,
        [name]: name + " is required",
      }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

useEffect(() => {
  const $select = $(selectOpt1.current);

  // Initialize Select2
  $select.select2({ width: "100%" });
    $select.select2({
    width: "100%",
    matcher: function(params, data) {
      if ($.trim(params.term) === "") {
        return data;
      }

      const search = params.term.replace(/\s+/g, "").toLowerCase();
      const text = (data.text || "").replace(/\s+/g, "").toLowerCase();

      if (text.indexOf(search) > -1) {
        return data;
      }
      return null;
    }
  });

  // Handle select
  const handleSelect = (e) => {
    const selectedValue = e.params.data.id;
    handleValidationRegMark("registrationMark", selectedValue);
  };

  $select.on("select2:select", handleSelect);


  // Cleanup
  return () => {
    $select.off("select2:select", handleSelect);
    $select.select2("destroy");
  };
}, [reg_mark]);

  useEffect(() => {
    const $select = $(selectOpt2.current);

    // Initialize Select2

    $select.select2({ width: "100%" });

    // Define event handlers
    const handleSelect = (e) => {
      //  debugger
      const selectedValue = e.params.data.id;
      handleValidationRegType("plateRegType", selectedValue);
    };

    // if (formData.passport_country) {
    //   $select.val(formData.passport_country).trigger("change");
    // }

    // Attach handlers
    $select.on("select2:select", (e) => handleSelect(e));

    // Cleanup
    return () => {
      $select.off("select2:select", handleSelect);
      $select.select2("destroy");
    };
  }, [reg_type]);

  const handleClose = () => {
    setOpenMessageBox(false);
  };

  const search_quote = async (payload) => {
    try {

       if(userData && userData.access_token){

        if(userData.type==="staff"){
          payload["user_type"]="staff";
        }
        else if(userData.agency_name){
         payload["user_type"]="agent";
        }
        else if(userData.first_name){
         payload["user_type"]="user";
        }
         payload["token"]=userData.access_token;
      }

      const response = await fetch(base_url + "/motor_search_quote", {
        method: "POST",
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + vendorKey,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("API request failed");

      const data = await response.json();

      return data;
    } catch (error) {
      console.log("unable to fetch data", error);
    }
  };

  const create_Quote = async () => {
    try {
      let plate_reg_id = 1;

      const payload = {
        civilId: formData.civilId,
        plateNo: formData.plateNo,
        registrationMark: formData.registrationMark,
        srcBusId: "SJET",
        chasisNo: "",
        mobileNo: formData.mobileNo,
        emailId: "",
        firstName: formData.firstName,
        lastName: "",
        plateRegType: plate_reg_id,
        product: formData.product,
        vehicleValue: formData.vehicleValue,
        policy_type:"new",
        user_type:null,
        token:null
      };

      if(userData && userData.access_token){

        if(userData.type==="staff"){
          payload["user_type"]="staff";
        }
        else if(userData.agency_name){
         payload["user_type"]="agent";
        }
        else if(userData.first_name){
         payload["user_type"]="user";
        }
         payload["token"]=userData.access_token;
      }

      const response = await fetch(base_url + "/create_quote_v2", {
        method: "POST",
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer" + vendorKey,
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("API request failed");
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error to create quote", error);
    }
  };

  useEffect(()=>{

    const buyPolicySession = sessionStorage.getItem("motorBuyPolicyDetails");
    if(buyPolicySession){
      const parseBuyPolicy =  JSON.parse(buyPolicySession);
      if(parseBuyPolicy){
        debugger
        setFormData(parseBuyPolicy);
        if(parseBuyPolicy?.product=="0502"){
           setActiveButton(2)
        }
        else if(parseBuyPolicy?.product=="0501"){
           setActiveButton(1)
        }
      }
    }
  },[])

  const handleCreateQuote = async (e) => {
    e.preventDefault();
debugger
    if (validateForm()) {
      setLoading(true);
      // console.log(formData, "shiva");
      sessionStorage.setItem("motorBuyPolicyDetails",JSON.stringify(formData))
      try {

        const policy_payload = {
          civilId: formData.civilId,
          plateNo: formData.plateNo,
          registrationMark: formData.registrationMark,
          srcBusId: "SJET",
          txnTyp: "P",
          mobileNo: formData.mobileNo,
          policyNo: "",
          quoteNo: "",
          policy_type:"new"
        };
        debugger;
        const searchData = await search_quote(policy_payload);

        const result = searchData.result.transactionDetails.errMsg;
        const regex = /No Policy found/;
        const extractResult = regex.test(result);

        if (searchData.message === "success" && extractResult) {
          //create quote
          const data = await create_Quote();
          // Create Quote response
          if (data.message === "success") {
            if(data.result==""){
                 setMessage("Quote not found.");
              setOpenMessageBox(true);
              return;
            }
            if (
              data.result.effectiveDt &&
              data.result.insuredDetails &&
              data.result.vehicleDetails
            ) {

              const quoteNo={
                quoteNo:data.result.transactionDetails.quoteNo ||data.result.renewalQuoteNo
              }
              sessionStorage.setItem("motorQuoteNo",JSON.stringify(quoteNo));
              sessionStorage.removeItem("communicationDetails");
              navigate("/motor-ins-quote-summary");

            } else if (data.result.errMsg.includes("Active quote")) {
              // 104/0502/2025/Q/000690
              const regex = /\b\d{3}\/\d{4}\/\d{4}\/Q\/\d+\b/;
              const match = data.result.errMsg.match(regex);

              if (match) {
                const quote_payload = {
                  civilId: "",
                  plateNo: "",
                  registrationMark: "",
                  srcBusId: "SJET",
                  txnTyp: "Q",
                  mobileNo: "",
                  policyNo: "",
                  quoteNo: match[0].trim(),
                  searchTyp: "",
                  policy_type:"new"
                };

                const searchData2 = await search_quote(quote_payload);
                if (searchData2.message === "success") {
                  if (searchData2.result.effectiveDt) {

                    const quoteNo={
                quoteNo:searchData2.result.transactionDetails.quoteNo || searchData2.result.renewalQuoteNo
              }
              sessionStorage.setItem("motorQuoteNo",JSON.stringify(quoteNo));
                    navigate("/motor-ins-quote-summary");

                  } else {
                    toast.error(
                      "Unable to fetch quote details. Please try again."
                    );
                    console.log("active quote error");
                    setMessage(data.result.errMsg);
                    setOpenMessageBox(true);
                  }
                }
              }
            } 
            else if (data.result.errMsg) {
              //model
              setMessage(data.result.errMsg);
              setOpenMessageBox(true);
            }
          }
        } else {
          setMessage("Already Active Policy Found...");
          setOpenMessageBox(true);
        }
      } catch (err) {
        console.error("Error in get quote process: ", err);
      } finally {
        setLoading(false);
      }
    } // validation end
  }; //get quote end here  ----



  useEffect(() => {
    const initialSession = sessionStorage.getItem("motorBasicDetails")
    if(initialSession){
    const initialDetails= JSON.parse(initialSession);
    if (initialDetails) {

      setFormData((prev) => ({
        ...prev,
        firstName: initialDetails.firstName,
        mobileNo: initialDetails.mobileNo,
      }));
    }
  }
  }, []);
  // const handleAssign =()=>{

  // }

  //  useEffect(() => setDetails(quoteDetails), []);

  return (
    <>
     {allow && 
     <>
      <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t("Buy Policy")}</h3>
          </div>
        </div>
      </div>

   <div className="features_section">
        <div className="container">
          <div className="row d-flex align-items-center justify-content-center">
            <div className="col-md-10 mt-4 p-4 border shadow rounded">
              <div className="row ">
                <div className="col-md-6 mb-2 ">
                  <label className="mb-0 mt-1 ">
                    {t("Mobile Number")}<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control "
                    ref={mobileNoRef}
                    value={formData?.mobileNo}
                    name="mobileNo"
                    //  onChange={handleChange}
                    onBlur={handleValidation}
                    disabled={formData?.mobileNo ? true : false}
                  />
                  {errors.mobileNo && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.mobileNo}
                    </span>
                  )}
                </div>
              </div>

              <div>
                <h3 className=" mt-1" style={{ color: "black" }}>
                  Mulkiya
                </h3>

                <div className="row  mb-4">
                  <div className=" col-md-6">
                    <label className="mb-0 mt-1 ">
                      {t("Plate Number")}<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control "
                      ref={plateNoRef}
                      value={formData?.plateNo}
                      name="plateNo"
                      onChange={handleChange}
                      onBlur={handleValidation}
                    />
                    {errors.plateNo && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.plateNo}
                      </span>
                    )}
                  </div>

                  <div className=" col-md-6 ">
                    <label className="mb-0 mt-1 ">
                      {t("Plate Code")}<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control"
                      name="registrationMark"
                      ref={selectOpt1}
                      value={formData.registrationMark}
                    >
                      {/* (A A) */}
                      <option style={{ fontSize: "14px" }} value={null}>
                        --{t("Select")}--
                      </option>
                      {reg_mark.map((option, index) => (
                        <option
                          style={{ fontSize: "14px" }}
                          key={index}
                          value={option}
                        >
                          {option}
                        </option>
                      ))}
                    </select>
                    {errors.registrationMark && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.registrationMark}
                      </span>
                    )}
                  </div>

                  <div className=" col-md-6">
                    <label className="mb-0 mt-1">
                      {t("Plate Type")}<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-control "
                      name="plateRegType"
                      ref={selectOpt2}
                      value={formData.plateRegType}
                      disabled
                    >
                      <option value={""}>Oman</option>
                      {reg_type.map((option, index) => (
                        <option
                          style={{ fontSize: "14px" }}
                          key={index}
                          value={option}
                        >
                          {option}
                        </option>
                      ))}
                    </select>
                    {errors.plateRegType && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.plateRegType}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-2">
                <h3 className="mb-0 mt-2 w-100 " style={{ color: "black" }}>
                  {t("Driving License")}
                </h3>
                {/* <button  className='btn btn-primary' style={{border:"1px solid black",mt: 3,left: 0,width:"100%",padding:"10px",textAlign:"center"}}>
                  Upload File
                  <input type="file" hidden/>
                </button> */}
                <div className="row">
                  <div className="col-md-6">
                    <label className="mb-0 mt-1">
                      {t("Civil ID/License Number")}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      ref={civilIdRef}
                      value={formData?.civilId}
                      name="civilId"
                      onChange={handleChange}
                      onBlur={handleValidation}
                    />
                    {errors.civilId && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.civilId}
                      </span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="mb-0 mt-1">
                      {t("Full Name")}<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      ref={firstNameRef}
                      value={formData?.firstName}
                      name="firstName"
                      //  disabled={initialDetails?.firstName ? true : false}

                      onBlur={handleValidation}
                      onChange={handleChange}
                    />
                    {errors.firstName && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.firstName}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div>
                <h3 className="mb-0 mt-2 w-100" style={{ color: "black" }}>
                  {t("Select Product")}
                  <span>
                    {errors.product && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {" "}
                        ({errors.product})
                      </span>
                    )}
                  </span>
                </h3>

                <div className="row">
                  <div className="col-md-6">
                    <button
                      className="col-md-12 mt-1"
                      name="product"
                      style={{
                        padding: "10px 10px",
                        border: "1px solid #3fd2f2",
                        backgroundColor:
                          activeButton === 1 ? " #3fd2f2" : "white",
                        color: activeButton === 1 ? " white" : "#3fd2f2",
                      }}
                      onClick={() => handleClick(1)}
                      onBlur={handleValidation}
                    >
                      {t("Comprehensive Insurance")}
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="col-md-12 mt-1"
                      name="product"
                      style={{
                        padding: "10px 10px",
                        border: "1px solid #3fd2f2",
                        backgroundColor:
                          activeButton === 2 ? " #3fd2f2" : "white",
                        color: activeButton === 2 ? " white" : "#3fd2f2",
                      }}
                      onClick={() => handleClick(2)}
                      onBlur={handleValidation}
                    >
                      {t("Third Party Insurance")}
                    </button>
                  </div>
                </div>

                <div className="row">{activeButton === 1 && (
                  <div className="col-md-6">
                    <label className="mb-0 mt-3">
                      {t("Vehicle Value (Sum Assured)")}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      ref={vehicleValueRef}
                      value={formData?.vehicleValue}
                      name="vehicleValue"
                      onChange={handleChange}
                      onBlur={handleValidation}
                    />
                    {errors.vehicleValue && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.vehicleValue}
                      </span>
                    )}
                  </div>
                )}
              </div>
              </div>
              <div className="col-md-12 p-0">
                <button
                  className="  mt-4 col-md-2"
                  style={{ backgroundColor: " #3fd2f2" }}
                  onClick={handleCreateQuote}
                >
                  {t("Get Quote")}
                </button>
              </div>

              {openMessageBox && (
                <div className="modal">
                  <div
                    className="modal-content"
                    style={{ height: "auto", width: "600px" }}
                  >
                    {/* <button type="button" className="close" onClick={handleClose}>
          &times;
          </button> */}

                    <div>
                      <div style={{ textAlign: "left" }}>{message}</div>

                      <hr></hr>
                      <div>
                        <button
                          type="button"
                          className="mt-3 btn btn-primary"
                          aria-label="Close"
                          onClick={handleClose}
                        >
                          {t("Close")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
      </>
            }

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default MotorInsuranceBuyPolicy;
